import React from 'react'
import { Link } from 'react-router-dom'
import phenom from '../../../assets/case_study/Phenom_CaseStudy.svg';
import goken from "../../../assets/case_study/Goken_CaseStudy.svg";
import ikf from "../../../assets/case_study/ikf_CaseStudy.svg";
import monitra from "../../../assets/case_study/Monitra_CaseStudy.svg";
import incuspaze from "../../../assets/case_study/incuspaze_caseStudy.svg";

export default function CaseStudyCards() {
    return (
        <>
            <div className="relative w-full header-container">
                <div className="header-content absolute inset-0 flex flex-col justify-center items-center text-center mt-12">
                    <h1 className="text-[50px] md:text-[54px] lg:text-[54px] font-medium text-white uppercase">
                        Case Study
                    </h1>

                    <div className="lg:w-[55%] w-full  mx-auto">
                        <p className="text-[18px] font-normal leading-relaxed text-white mb-10 text-center">
                            These case studies highlight how companies optimized workflows, embraced digital transformation, and improved outcomes by adapting to changing market demands and customer expectations.
                        </p>
                    </div>
                </div>
            </div>

            {/* Cards container moved outside header-container */}
            <div className="max-w-7xl mx-auto my-4 px-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {/* Card links here */}
                    <Link to="/case-study/phenom">
                        <div className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col h-full">
                            <img
                                className="w-full h-48 object-cover"
                                src={phenom}
                                alt="Card Image"
                            />
                            <div className="p-4 flex-1 flex flex-col">
                                <h3 className="text-xl font-semibold mb-2">Phenom</h3>
                                <p className="text-gray-600 text-sm flex-1">
                                    The Phenom Intelligent Talent Experience platform connects your people, data, and interactions to deliver amazing experiences throughout the journey using intelligence and automation.
                                </p>
                            </div>
                        </div>
                    </Link>
                    {/* Other cards ... */}
                    <Link to="/case-study/incuspaze">
                        <div className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col h-full">
                            <img
                                className="w-full h-48 object-cover"
                                src={incuspaze}
                                alt="Card Image"
                            />
                            <div className="p-4 flex-1 flex flex-col">
                                <h3 className="text-xl font-semibold mb-2">Incuspaze</h3>
                                <p className="text-gray-600 text-sm flex-1">
                                    At Incuspaze, we cater to enterprises with 100+ team members. Our workspaces blend high-end amenities, aesthetics, and functionality.
                                </p>
                            </div>
                        </div>
                    </Link>
                    <Link to="/case-study/monitra">
                        <div className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col h-full">
                            <img
                                className="w-full h-48 object-cover"
                                src={monitra}
                                alt="Card Image"
                            />
                            <div className="p-4 flex-1 flex flex-col">
                                <h3 className="text-xl font-semibold mb-2">Monitra</h3>
                                <p className="text-gray-600 text-sm flex-1">
                                    Monitra Healthcare is a cutting-edge health technology company dedicated to improving patient outcomes through smart monitoring solutions.
                                </p>
                            </div>
                        </div>
                    </Link>
                    <Link to="/case-study/goken">
                        <div className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col h-full">
                            <img
                                className="w-full h-48 object-cover"
                                src={goken}
                                alt="Card Image"
                            />
                            <div className="p-4 flex-1 flex flex-col">
                                <h3 className="text-xl font-semibold mb-2">Goken</h3>
                                <p className="text-gray-600 text-sm flex-1">
                                    As a nimble engineering service provider, we work closely with our clients to build better products every step of the way.
                                </p>
                            </div>
                        </div>
                    </Link>
                    <Link to="/case-study/ikf">
                        <div className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col h-full">
                            <img
                                className="w-full h-48 object-cover"
                                src={ikf}
                                alt="Card Image"
                            />
                            <div className="p-4 flex-1 flex flex-col">
                                <h3 className="text-xl font-semibold mb-2">IKF Finance</h3>
                                <p className="text-gray-600 text-sm flex-1">
                                    IKF Finance’s mission and vision reflect a strong commitment to societal advancement.
                                </p>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </>
    )
}